import { specialOffersActions } from 'affiny-core/modules/specialOffers/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useDispatchGetSpecialOffer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(specialOffersActions.getCurrentSpecialOffer());
  }, []);
};
